module.exports = __webpack_public_path__ + "static/media/comefunziona2.0bbe6773.png";